export default __webpack_public_path__ + "static/media/logo-membrzclub.aafd8cc3.png";